import React from 'react'
import styles from './WindowTitle.styles'
import { makeStyles } from '@material-ui/core/styles'
import ButtonLogIn from '../buttonLogIn/ButtonLogIn'
import Localization from '@voicekey/components-base/localization/Localization'
import { APP_LANGUAGES } from 'store/localeStore'
import { useStore } from 'store/useStore'
import Button from '@material-ui/core/Button'
import { useHistory } from 'react-router'
import LINKS from 'App.const'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import { useAnchorEl } from '@voicekey/libraries/useAnchorEl/useAnchorEl'
import Menu from '../menu/Menu'
import { observer } from 'mobx-react-lite'

const useStyles = makeStyles(styles, { name: 'WindowTitle' })

function WindowTitle () {
  const classes = useStyles()

  const { localeStore, sessionStore } = useStore()

  const history = useHistory()

  const openMainPage = () => {
    history.push(LINKS.MAIN.PROJECTS_PAGE.path)
  }

  const changeLanguage = language => {
    localeStore.locale = language
  }

  const [anchorEl, handleMenuClick, handleMenuClose] = useAnchorEl()

  return (
    <div className={classes.main}>
      <Button
        className={classes.titleButton}
        onClick={openMainPage}
        variant='text'
        disableRipple
      >
        VoiceKey Portal
      </Button>
      <div>
        {sessionStore.sessionId ? (
          <Button onClick={handleMenuClick} variant='text' disableRipple>
            {sessionStore.username}
            <KeyboardArrowDownIcon />
          </Button>
        ) : (
          <ButtonLogIn />
        )}
        <Menu anchorEl={anchorEl} handleMenuClose={handleMenuClose} />
        <Localization
          className={classes.localization}
          languages={Object.values(APP_LANGUAGES)}
          locale={localeStore.locale}
          onChangeLocale={changeLanguage}
        />
      </div>
    </div>
  )
}

export default observer(WindowTitle)
